"use strict";
// ==========================================
// Core Game Types
// ==========================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeathReason = exports.GamePhase = void 0;
var GamePhase;
(function (GamePhase) {
    GamePhase["WAITING"] = "WAITING";
    GamePhase["PLAYING"] = "PLAYING";
    GamePhase["SHRINKING"] = "SHRINKING";
    GamePhase["FINAL"] = "FINAL";
    GamePhase["ENDED"] = "ENDED";
})(GamePhase || (exports.GamePhase = GamePhase = {}));
var DeathReason;
(function (DeathReason) {
    DeathReason["COLLISION"] = "COLLISION";
    DeathReason["HEAD_ON"] = "HEAD_ON";
    DeathReason["RED_ZONE"] = "RED_ZONE";
    DeathReason["DISCONNECT"] = "DISCONNECT";
    DeathReason["SESSION_END"] = "SESSION_END";
    DeathReason["COLLAPSE"] = "COLLAPSE";
    DeathReason["CHEATING"] = "CHEATING";
    DeathReason["ADMIN_KICK"] = "ADMIN_KICK";
})(DeathReason || (exports.DeathReason = DeathReason = {}));
//# sourceMappingURL=types.js.map